/**
 * Signup-järgse WP-impordi seisu-poll (funnel tee 3, koondplaan §7.2 samm 4).
 * Kui külastaja skannis avalikus `/alusta`-funnelis oma vana WP-saidi ja
 * registreerus, jookseb konverteerimine backendis TAUSTAL; `ImportProgressPage`
 * pollib siit seisu, näitab „ehitame su saiti" edenemist ja lõpuks tulemust.
 */
import { api } from "./api";

export type ImportStatus = "none" | "queued" | "running" | "done" | "failed";

/** Jooksva impordi PÄRIS faas (backend `wp.service.ts` ImportPhase) - progress-
 *  vaate sammud liiguvad selle järgi. `null` = pole veel raporteeritud (queued). */
export type ImportPhase = "branding" | "pages" | "posts" | "menus" | "finalizing";

/** Jooksva impordi loendurid + ETA. `total` null = koguarv teadmata (X-WP-Total
 *  tõrge); piltide koguarvu ei tea keegi ette → ainult jooksev arv. `etaSeconds`
 *  on kirje-tempo pealt ekstrapoleeritud hinnang, null kuni usaldusväärne. */
export interface ImportProgress {
  pagesDone: number;
  pagesTotal: number | null;
  postsDone: number;
  postsTotal: number | null;
  imagesDone: number;
  etaSeconds: number | null;
}

export interface ImportState {
  status: ImportStatus;
  /** Ainult `running` ajal; muidu null. */
  phase: ImportPhase | null;
  /** Ainult `running` ajal; muidu null. */
  progress: ImportProgress | null;
  url: string | null;
  aiPromoted: boolean;
  startedAt: string | null;
  finishedAt: string | null;
  stats: { pages: number; posts: number; images: number } | null;
  /** Enne/pärast kuvatõmmised (R2/CDN URL-id); puudub, kui Browser Rendering väljas. */
  shots: { before?: string; after?: string } | null;
  error: string | null;
  host: string | null;
  slug: string | null;
}

/** Loe konkreetse saidi impordi-seis. Viskab `ApiError` (nt 404 = pole ligipääsu). */
export function getImportStatus(siteId: string): Promise<ImportState> {
  return api.get<ImportState>(`/account/sites/${encodeURIComponent(siteId)}/import-status`);
}

/**
 * „Anna teada, kui valmis" opt-in: talleta e-posti/push-eelistus. Taust-töö lõpp
 * (VÕI juba-valmis puhul kohe) saadab teate. Vähemalt üks kanal peab olema.
 */
export function setImportNotify(
  siteId: string,
  prefs: { email?: string; push?: boolean; locale?: string },
): Promise<{ ok: true }> {
  return api.post<{ ok: true }>(`/account/sites/${encodeURIComponent(siteId)}/import-notify`, prefs);
}
